import React, { useContext } from 'react';
import styled from 'styled-components';
import { QueryBuilder } from '@/components/query-builder';
import { StrategyPerSlotContext } from '@/features/editor/widgets/custom-widget/loading-section/strategy-per-slot/context/context';
import { RecommendationType } from '@/webapi/use-widget-catalog-api';
import { useConditionalQueryBuilder } from '@/features/editor/widgets/custom-widget/loading-section/util/useQueryBuilder';
import { VSpace } from '@/components/spacing';

export function ProductFilters() {
  const ctx = useContext(StrategyPerSlotContext);
  const { isGlobalFilterOpen } = ctx;

  if (!ctx.isProductCondOpen && !isGlobalFilterOpen) {
    return null;
  }

  const { condition } = useConditionalQueryBuilder(
    isGlobalFilterOpen
      ? RecommendationType.MOST_POPULAR
      : ctx?.getOpenCondSlot()?.strategy || RecommendationType.MANUAL,
  );

  return (
    <Container>
      <QueryBuilder
        onChange={(x) =>
          isGlobalFilterOpen ? ctx.setGlobalFilter(x) : ctx.setSlotCond(x)
        }
        initialProps={condition}
        initialState={
          isGlobalFilterOpen ? ctx.globalFilter : ctx.getCurrentCond()
        }
      />
      <VSpace value={3} />
    </Container>
  );
}

const Container = styled.div`
  min-width: 80rem;
  width: 100%;
  padding: 0 4rem 4rem;
  overflow-y: auto;
`;
